import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API()+'trasy/';

export default {

    getTrasy() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    getTrasyZRezerwacja(){
        return axios({
            method: 'get',
            url: URL + 'rezerwacje',
        });
    },

    addTrasa(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editTrasa(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deleteTrasa(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/trasy/TrasyService.js